import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Dropdown from "./Dropdown";
import ExerciseCard from "./ExerciseCard";

const Exercises = ({ data }) => {
  const [muscleGroups, setMuscleGroups] = useState([]);
  const [primeMoverMuscles, setPrimeMoverMuscles] = useState([]);
  const [difficultyLevels, setDifficultyLevels] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedPrimeMover, setSelectedPrimeMover] = useState("");
  const [selectedDifficulty, setSelectedDifficulty] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  // Daten für Filter extrahieren
  useEffect(() => {
    if (!data.length) return;

    const groups = [...new Set(data.map((exercise) => exercise["Target Muscle Group"]))].filter(Boolean);
    setMuscleGroups(groups);

    const primeMovers = [...new Set(data.map((exercise) => exercise["Prime Mover Muscle"]))].filter(Boolean);
    setPrimeMoverMuscles(primeMovers);

    const difficulties = [...new Set(data.map((exercise) => exercise["Difficulty Level"]))].filter(Boolean);
    setDifficultyLevels(difficulties);
  }, [data]);

  // Gefilterte Prime Mover basierend auf der ausgewählten Muskelgruppe
  const getFilteredPrimeMovers = useCallback(() => {
    if (!selectedGroup) return primeMoverMuscles;
    
    return [...new Set(
      data
        .filter(exercise => exercise["Target Muscle Group"] === selectedGroup)
        .map(exercise => exercise["Prime Mover Muscle"])
    )].filter(Boolean);
  }, [data, selectedGroup, primeMoverMuscles]);

  // Wenn sich die Muskelgruppe ändert, setzen wir den Prime Mover zurück
  useEffect(() => {
    setSelectedPrimeMover("");
  }, [selectedGroup]);

  // Filterlogik
  useEffect(() => {
    let filtered = data;

    if (selectedGroup) {
      filtered = filtered.filter((exercise) => exercise["Target Muscle Group"] === selectedGroup);
    }

    if (selectedPrimeMover) {
      filtered = filtered.filter((exercise) => exercise["Prime Mover Muscle"] === selectedPrimeMover);
    }

    if (selectedDifficulty) {
      filtered = filtered.filter((exercise) => exercise["Difficulty Level"] === selectedDifficulty);
    }

    setFilteredData(filtered);
  }, [data, selectedGroup, selectedPrimeMover, selectedDifficulty]);

  // URL-Parameter auslesen und setzen
  useEffect(() => {
    const group = searchParams.get("group") || "";
    const primeMover = searchParams.get("primeMover") || "";
    const difficulty = searchParams.get("difficulty") || "";

    if (group) setSelectedGroup(group);
    if (primeMover) setSelectedPrimeMover(primeMover);
    if (difficulty) setSelectedDifficulty(difficulty);
  }, [searchParams]);

  // URL-Parameter aktualisieren
  const updateSearchParams = useCallback(() => {
    const params = {};
    if (selectedGroup) params.group = selectedGroup;
    if (selectedPrimeMover) params.primeMover = selectedPrimeMover;
    if (selectedDifficulty) params.difficulty = selectedDifficulty;
    setSearchParams(params);
  }, [selectedGroup, selectedPrimeMover, selectedDifficulty, setSearchParams]);

  useEffect(() => {
    updateSearchParams();
  }, [updateSearchParams]);

  if (!muscleGroups.length || !primeMoverMuscles.length || !difficultyLevels.length) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container">
      <h1>Übungen filtern</h1>
      <div className="dropdown-container">
        <Dropdown
          options={muscleGroups}
          value={selectedGroup}
          onChange={(group) => setSelectedGroup(group)}
          placeholder="Muskelgruppen"
        />
        <Dropdown
          options={getFilteredPrimeMovers()}
          value={selectedPrimeMover}
          onChange={(primeMover) => setSelectedPrimeMover(primeMover)}
          placeholder="Prime Mover"
        />
        <Dropdown
          options={difficultyLevels}
          value={selectedDifficulty}
          onChange={(difficulty) => setSelectedDifficulty(difficulty)}
          placeholder="Schwierigkeitsstufen"
        />
      </div>
      <div className="card-container">
        {filteredData.map((exercise, index) => (
          <ExerciseCard key={index} exercise={exercise} />
        ))}
      </div>
    </div>
  );
};

export default Exercises;